import { createTheme, globalTheme } from '@clds/component-theme';

export const wizardTheme = createTheme(
  {
    step: {
      background: {
        color: {
          hover: globalTheme.palette.primary,
          incomplete: globalTheme.palette.secondary,
          active: globalTheme.palette.primary,
          completed: globalTheme.palette.success,
          disabled: globalTheme.palette.secondary,
          error: globalTheme.palette.error,
        },
      },
      font: {
        color: {
          hover: globalTheme.palette.primary,
          incomplete: globalTheme.palette.contrastLow,
          active: globalTheme.palette.primary,
          completed: globalTheme.palette.contrastInvert,
          disabled: globalTheme.palette.contrastLow,
          error: globalTheme.palette.contrastInvert,
        },
      },
      border: {
        radius: globalTheme.radius.round,
      },
    },
    connector: {
      color: {
        incomplete: globalTheme.palette.secondaryAlt,
        active: globalTheme.palette.primary,
        completed: globalTheme.palette.success,
        disabled: globalTheme.palette.secondaryAlt,
        error: globalTheme.palette.error,
      },
    },
    label: {
      font: {
        color: {
          hover: globalTheme.palette.primary,
          incomplete: globalTheme.palette.contrastHigh,
          active: globalTheme.palette.primary,
          completed: globalTheme.palette.contrastHigh,
          disabled: globalTheme.palette.contrastHigh,
          error: globalTheme.palette.contrastHigh,
        },
        size: globalTheme.font.size.xs,
      },
    },
  },
  'wizard'
);
